import { Component } from "react";
import { connect } from "react-redux";
import DataTable from "components/DigiHapi/DataTable";
import { bindActionCreators } from "redux";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// DigiHapi components
import SnackBarContainer from "components/DigiHapi/SnackBarContainer";
import MDWizard from "components/DigiHapi/MDWizard";

import {
	fetchGetNeighborhoodDetails,
	fetchGetNeighborhoodsNames,
	fetchDeleteNeighborhood,
	fetchAddNeighborhood,
	fetchUpdateNeighborhood
} from "actions/neighborhood";
import { fetchGetCommunityDetails } from "actions/community";
import {
	RESET_NEIGHBORHOOD,
	SET_NEIGHBORHOODS_SORTED,
	SET_DELETE_NEIGHBORHOOD_CONFIRMATION_NAME,
	SET_NEIGHBORHOODS_NAME_FILTER,
	SET_NEW_NEIGHBORHOOD_WIZARD,
	ROLE_EMPLOYEE
} from "actions/types";

import DeleteConfirmationDialog from "components/DigiHapi/DeleteConfirmationDialog";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";

const { REACT_APP_DEEPLINK_URL = "https://app.hapicolibri.digihapi.com" } =
	process.env;

class NeighborhoodsWizard extends Component {
	fetchAddNeighborhood = () => {
		const {
			fetchAddNeighborhood,
			isVisible,
			isPrivate,
			name,
			customUri,
			logoUri,
			address,
			zipCode,
			city,
			webSiteUrl,
			mail,
			loc,
			phone,
			fax,
			registerkey,
			files,
			channels,
			building,
			residence,
			district,
			organizationId
		} = this.props;

		fetchAddNeighborhood({
			isVisible,
			isPrivate,
			name,
			customUri,
			logoUri,
			address,
			zipCode,
			city,
			webSiteUrl,
			mail,
			loc,
			phone,
			fax,
			registerkey,
			files,
			channelsIds: Object.values(channels),
			building,
			residence,
			district,
			organizationId
		});
	};

	fetchUpdateNeighborhood = () => {
		const {
			fetchUpdateNeighborhood,
			isVisible,
			isPrivate,
			_id,
			name,
			customUri,
			registerkey,
			address,
			zipCode,
			city,
			webSiteUrl,
			mail,
			loc,
			phone,
			fax,
			files,
			logoUri,
			mapUri,
			mapSmallUri,
			equipmentsIds,
			channels,
			building,
			residence,
			district
		} = this.props;

		fetchUpdateNeighborhood({
			isVisible,
			_id,
			isPrivate,
			name,
			customUri,
			registerkey,
			address,
			zipCode,
			city,
			webSiteUrl,
			mail,
			loc,
			phone,
			fax,
			files,
			logoUri,
			mapUri,
			mapSmallUri,
			equipmentsIds,
			channelsIds: Object.values(channels),
			building,
			residence,
			district
		});
	};

	render() {
		const { update, isFetching, onClose } = this.props;
		return (
			<Grid item xs={12}>
				<MDWizard
					onClose={onClose}
					isFetching={isFetching}
					validate
					steps={[
						{
							stepName: "Illustration",
							stepComponent: Step1,
							stepId: "picture"
						},
						{
							stepName: "Informations",
							stepComponent: Step2,
							stepId: "infos"
						},
						{
							stepName: "Localisation",
							stepComponent: Step3,
							stepId: "localisation"
						}
					]}
					title={
						update
							? "Mise à jour d'une communauté de voisinage"
							: "Ajout d'une communauté de voisinage"
					}
					finishButtonClick={
						update ? this.fetchUpdateNeighborhood : this.fetchAddNeighborhood
					}
				/>
			</Grid>
		);
	}
}

class NeighborhoodsPage extends Component {
	state = {
		wizard: null,
		neighborhoodToDelete: null,
		name: ""
	};

	componentDidMount() {
		this.props.fetchGetNeighborhoodsNames({
			organizationId: this.props.organizationId
		});
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			fetchGetNeighborhoodsNames,
			snackInfoMsg,
			newWizard,
			page,
			limit,
			sorted,
			nameFilter,
			organizationId
		} = this.props;

		if (snackInfoMsg && prevProps.snackInfoMsg !== snackInfoMsg) {
			this.setState({
				wizard: null
			});
			fetchGetNeighborhoodsNames({
				page,
				pageSize: limit,
				sorted,
				name: nameFilter,
				organizationId
			});
		}

		if (newWizard && prevProps.newWizard !== newWizard) {
			this.addWizard(newWizard === "update");
		}
	}

	onClose = () => {
		this.setState({
			wizard: null
		});
		this.props.dispatch({
			type: RESET_NEIGHBORHOOD
		});
	};

	addWizard = (update = true) => {
		this.setState({
			wizard: (
				<ConnectedNeighborhoodsWizard update={update} onClose={this.onClose} />
			)
		});
	};

	changeCommunity = id => {
		this.props.fetchGetCommunityDetails(id);
	};

	editNeighborhood = id => {
		this.props.fetchGetNeighborhoodDetails(id);
	};

	deleteNeighborhood = id => {
		this.props.fetchDeleteNeighborhood(id, this.props.deleteConfirmationName);
	};

	getRoundButtons = (id, name, pdfUri, customUri) => {
		const { role } = this.props;
		return (
			role === ROLE_EMPLOYEE
				? [
						{
							color: "success",
							icon: "check_circle",
							onClick: this.changeCommunity,
							tooltip: "Selectionner la communauté"
						},
						...(customUri
							? [
									{
										color: "warning",
										icon: "mobile_screen_share",
										href: `${REACT_APP_DEEPLINK_URL}/${customUri}/actualites`,
										target: "_blank",
										tooltip: "Ouvrir sur mobile"
									}
							  ]
							: []),
						...(pdfUri
							? [
									{
										color: "primary",
										icon: "picture_as_pdf",
										href: pdfUri,
										target: "_blank",
										tooltip: "Ouvrir le PDF d'accueil"
									}
							  ]
							: [])
				  ]
				: [
						{
							color: "success",
							icon: "check_circle",
							onClick: this.changeCommunity,
							tooltip: "Selectionner la communauté"
						},
						...(customUri
							? [
									{
										color: "warning",
										icon: "mobile_screen_share",
										href: `${REACT_APP_DEEPLINK_URL}/${customUri}/actualites`,
										target: "_blank",
										tooltip: "Ouvrir sur mobile"
									}
							  ]
							: []),
						...(pdfUri
							? [
									{
										color: "primary",
										icon: "picture_as_pdf",
										href: pdfUri,
										target: "_blank",
										tooltip: "Ouvrir le PDF d'accueil"
									}
							  ]
							: []),
						{
							color: "info",
							icon: "edit",
							onClick: this.editNeighborhood,
							tooltip: "Modifier"
						},
						{
							color: "error",
							icon: "delete",
							onClick: this.delete,
							tooltip: "Supprimer"
						}
				  ]
		).map(({ color, icon, onClick, tooltip, ...props }) => (
			<Tooltip key={icon} title={tooltip} placement="bottom">
				<span>
					<MDButton
						variant="gradient"
						color={color}
						size="small"
						iconOnly
						circular
						disabled={!!this.state.wizard}
						onClick={() => onClick?.(id, name)}
						sx={{ mx: 0.25 }}
						{...props}
					>
						<Icon>{icon}</Icon>
					</MDButton>
				</span>
			</Tooltip>
		));
	};

	getNeighborhoods = () => {
		const { neighborhoodsNames } = this.props;

		const neighborhoodsObj = Object.values(neighborhoodsNames).map(
			({ _id, name, pdfUri, customUri }) => {
				return {
					name,
					actions: (
						<div className="actions-right">
							{this.getRoundButtons(_id, name, pdfUri, customUri)}
						</div>
					)
				};
			}
		);
		return neighborhoodsObj;
	};

	delete = (neighborhoodId, neighborhoodName) => {
		this.setState({
			neighborhoodToDelete: { id: neighborhoodId, name: neighborhoodName }
		});
	};

	render() {
		const { neighborhoodToDelete } = this.state;
		const {
			isFetchingList,
			dispatch,
			page,
			totalPages,
			limit,
			sorted,
			fetchGetNeighborhoodsNames,
			nameFilter,
			snackInfoMsg,
			snackErrorMsg,
			organizationId,
			role
		} = this.props;

		return (
			<SnackBarContainer
				snackInfoMsg={snackInfoMsg}
				snackErrorMsg={snackErrorMsg}
			>
				<Grid container spacing={3} justifyContent="center">
					<Grid item xs={12}>
						<Card>
							<MDBox
								mx={2}
								mt={-3}
								py={2}
								px={2}
								variant="gradient"
								bgColor="primary"
								borderRadius="lg"
								coloredShadow="primary"
								display="flex"
								alignItems="center"
								color="white"
							>
								<Icon fontSize="medium">apartment</Icon>
								<MDTypography variant="h6" color="white" ml={1.5}>
									Communautés de voisinage
								</MDTypography>
							</MDBox>
							<MDBox p={2}>
								<DataTable
									data={this.getNeighborhoods()}
									filterable
									columns={[
										{
											Header: "Nom",
											accessor: "name",
											sortable: true,
											filterable: true
										},
										{
											Header: "Actions",
											accessor: "actions",
											sortable: false,
											filterable: false
										}
									]}
									showPaginationTop
									showPaginationBottom={false}
									manual
									manualFilters
									onFetchData={state => {
										if (
											page !== state.page + 1 ||
											limit !== state.pageSize ||
											sorted !== state.sorted ||
											nameFilter !== state.filtered?.[0]?.value
										) {
											dispatch({
												type: SET_NEIGHBORHOODS_SORTED,
												value: state.sorted
											});
											dispatch({
												type: SET_NEIGHBORHOODS_NAME_FILTER,
												value: state.filtered?.[0]?.value
											});
											fetchGetNeighborhoodsNames({
												page: state.page + 1,
												pageSize: state.pageSize,
												sorted: state.sorted,
												name: state.filtered?.[0]?.value,
												organizationId
											});
										}
									}}
									loading={isFetchingList}
									defaultPageSize={limit}
									defaultSorted={sorted}
									page={page - 1}
									pageSizeOptions={[5, 10, 15, 20, 40, 80]}
									pages={totalPages}
									previousText="Précédent"
									nextText="Suivant"
									rowsText="Lignes"
									noDataText="Aucunes communautés de voisinage"
									ofText="sur"
									loadingText="Chargement..."
								/>
							</MDBox>
							{role !== ROLE_EMPLOYEE && (
								<MDBox p={2} display="flex" justifyContent="flex-end" gap={1}>
									<MDButton
										variant="gradient"
										color="primary"
										onClick={() => {
											dispatch({
												type: SET_NEW_NEIGHBORHOOD_WIZARD,
												value: "add"
											});
										}}
										disabled={Boolean(this.state.wizard)}
									>
										<Icon>add</Icon>
										&nbsp;{"Ajout d'une communauté de voisinage"}
									</MDButton>
								</MDBox>
							)}
						</Card>
					</Grid>
					{this.state.wizard}
				</Grid>
				<DeleteConfirmationDialog
					open={!!neighborhoodToDelete}
					message="Êtes-vous sûr de vouloir supprimer la communauté de voisinage ?"
					instruction={`Confirmer la suppression de la communauté de voisinage en saisisant le nom de la communauté ${neighborhoodToDelete?.name}`}
					inputLabel="Non de la communauté ..."
					inputId="neighborhood"
					onInputChange={e =>
						dispatch({
							type: SET_DELETE_NEIGHBORHOOD_CONFIRMATION_NAME,
							value: e.target.value
						})
					}
					onCancel={() => this.setState({ neighborhoodToDelete: null })}
					onConfirm={() => {
						this.deleteNeighborhood(neighborhoodToDelete.id);
						this.setState({ neighborhoodToDelete: null });
					}}
				/>
			</SnackBarContainer>
		);
	}
}

const mapStateToProps = state => {
	const {
		_id,
		isFetching,
		isFetchingList,
		isVisible,
		isPrivate,
		name,
		customUri,
		address,
		zipCode,
		city,
		webSiteUrl,
		mail,
		loc,
		phone,
		fax,
		registerkey,
		files,
		snackInfoMsg,
		snackErrorMsg,
		logoUri,
		mapUri,
		mapSmallUri,
		newWizard,
		equipmentsIds,
		deleteConfirmationName,
		channels,
		citiesTags,
		building,
		residence,
		district,
		neighborhoodsNames,
		page,
		hasNextPage,
		nextPage,
		totalPages,
		totalDocs,
		limit,
		sorted,
		nameFilter
	} = state.neighborhoodReducer;

	const { role } = state.profileReducer;

	const {
		organization: { _id: organizationId, organizationCommunityType }
	} = state.entitiesReducer;

	return {
		_id,
		isFetching,
		isFetchingList,
		isVisible,
		isPrivate,
		name,
		customUri,
		address,
		zipCode,
		city,
		webSiteUrl,
		mail,
		loc,
		phone,
		fax,
		registerkey,
		files,
		snackInfoMsg,
		snackErrorMsg,
		logoUri,
		mapUri,
		mapSmallUri,
		newWizard,
		equipmentsIds,
		deleteConfirmationName,
		channels,
		citiesTags,
		building,
		residence,
		district,
		neighborhoodsNames,
		page,
		hasNextPage,
		nextPage,
		totalPages,
		totalDocs,
		limit,
		sorted,
		nameFilter,
		role,
		...(organizationCommunityType === "Neighborhood" ? { organizationId } : {})
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchGetNeighborhoodsNames,
			fetchGetNeighborhoodDetails,
			fetchDeleteNeighborhood,
			fetchAddNeighborhood,
			fetchUpdateNeighborhood,
			fetchGetCommunityDetails
		},
		dispatch
	);
	return { ...actions, dispatch };
};

const ConnectedNeighborhoodsWizard = connect(
	mapStateToProps,
	mapDispatchToProps
)(NeighborhoodsWizard);

export default {
	NeighborhoodsPage: connect(
		mapStateToProps,
		mapDispatchToProps
	)(NeighborhoodsPage),
	NeihborhoodsWizard: ConnectedNeighborhoodsWizard
};
